<template>
  <div
      class="creator-search"
      :class="
      this.searchDisabled ? 'creator-search-disabled' : 'creator-search-active'
    "
  >
    <h2 class="creator-search__heading">
      Select one or more actions below. <br/>
      NB: Word Combi will require you to enter more than one source word and
      will then come up with a range of interesting combinations based on these
      source words.
    </h2>

    <div class="creator-search__options-row">
      <div class="creator-search__option-wrapper">
        <label class="creator-search__option">
          <FormulateInput
              v-model="searchOptions"
              type="checkbox"
              value="autogen"
              :outer-class="['creator-search__checkbox-wrapper']"
              :element-class="['formulate-input-element--checkbox-small']"
          />
          <span>AutoGen</span>
          <tooltip
              class="creator-search__tooltip"
              content="Ideas based on your input"
          />
        </label>
      </div>

      <div class="creator-search__option-wrapper">
        <label class="creator-search__option">
          <FormulateInput
              v-if="!isKeywordsMultiple"
              v-model="searchOptions"
              type="checkbox"
              value="word_combi"
              :outer-class="['creator-search__checkbox-wrapper']"
              :element-class="['formulate-input-element--checkbox-small']"
              disabled="disabled"
          />
          <FormulateInput
              v-else
              v-model="searchOptions"
              type="checkbox"
              value="word_combi"
              :outer-class="['creator-search__checkbox-wrapper']"
              :element-class="['formulate-input-element--checkbox-small']"
          />
          <span>WordCombi</span>
          <tooltip
              class="creator-search__tooltip"
              content="Mix keywords to create a new name"
          />
        </label>
      </div>

      <div class="creator-search__option-wrapper">
        <label class="creator-search__option">
          <FormulateInput
              v-model="searchOptions"
              type="checkbox"
              value="rewrite"
              :outer-class="['creator-search__checkbox-wrapper']"
              :element-class="['formulate-input-element--checkbox-small']"
          />
          <span>Rewrite</span>
          <tooltip
              class="creator-search__tooltip"
              content="Play with the spelling to come up with something new"
          />
        </label>
      </div>


      <div class="creator-search__option-wrapper">
        <label class="creator-search__option">
          <FormulateInput
              v-model="searchOptions"
              type="checkbox"
              value="urbanedge"
              :outer-class="['creator-search__checkbox-wrapper']"
              :element-class="['formulate-input-element--checkbox-small']"
          />
          <span>UrbanEdge</span>
          <tooltip
              class="creator-search__tooltip"
              content="Give your brand name some attitude"
          />
        </label>
      </div>

      <div class="creator-search__option-wrapper">
        <label class="creator-search__option">
          <FormulateInput
              v-model="searchOptions"
              type="checkbox"
              value="rhyme"
              :outer-class="['creator-search__checkbox-wrapper']"
              :element-class="['formulate-input-element--checkbox-small']"
          />
          <span>Rhyme</span>
          <tooltip
              class="creator-search__tooltip"
              content="Generate a list of rhyming words based on keywords"
          />
        </label>
      </div>

      <div class="creator-search__option-wrapper">
        <label class="creator-search__option">
          <FormulateInput
              v-model="searchOptions"
              type="checkbox"
              value="translations"
              :outer-class="['creator-search__checkbox-wrapper']"
              :element-class="['formulate-input-element--checkbox-small']"
          />
          <span>Translate</span>
          <tooltip
              class="creator-search__tooltip"
              content="See your brand name in translation"
          />
        </label>
      </div>
      <div v-if="searchOptions.includes('translations')" class="creator-search__option-wrapper_small">
        <FormulateInput
            type="select"
            :options="languages"
            v-model="selectedLanguage"
        />
      </div>

    </div>

    <p v-if="searchFormError.error" class="formulate-input-error">
      {{ searchFormError.text }}
    </p>

    <div class="creator-search__options-row">
      <div class="creator-search__search-btn-wrapper">
        <button
            type="button"
            class="btn creator-search__search-btn"
            @click="searchClicked"
        >
          <span>Search</span>
          <svg
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M13.255 11.255H12.465L12.185 10.985C13.165 9.845 13.755 8.365 13.755 6.755C13.755 3.165 10.845 0.255005 7.255 0.255005C3.665 0.255005 0.755005 3.165 0.755005 6.755C0.755005 10.345 3.665 13.255 7.255 13.255C8.865 13.255 10.345 12.665 11.485 11.685L11.755 11.965V12.755L16.755 17.745L18.245 16.255L13.255 11.255ZM7.255 11.255C4.76501 11.255 2.755 9.245 2.755 6.755C2.755 4.26501 4.76501 2.255 7.255 2.255C9.745 2.255 11.755 4.26501 11.755 6.755C11.755 9.245 9.745 11.255 7.255 11.255Z"
                fill="black"
                fill-opacity="0.87"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from "@/components/ui/Tooltip";
import axios from "axios";

export default {
  name: "creatorSearchOptions",
  props: {
    searchFormError: {
      type: Object,
      required: true,
    },
    searchDisabled: {
      type: Number,
      required: true,
    },
    konstruktor_word: {
      type: String,
      required: true,
    },
  },
  components: {
    Tooltip,
  },
  data() {
    return {
      languages: ["ES", "FR", "DE", "ZH", "AR", "IT", "LA", "JA", "PT", "RU"],
      searchOptions: [],
      isKeywordsMultiple: false,
      selectedLanguage: 'ES',
    };
  },
  watch: {
    searchOptions: function (data) {
      this.$emit("search-options-updated", data);
    },
    selectedLanguage: function (data) {
      this.$emit("update-selected-language", data);
    },
    konstruktor_word: function (data) {
      this.isKeywordsMultiple = data.split(' ').length > 1;
    }
  },
  methods: {
    fetchActivePlan() {
      const userId = sessionStorage.getItem("user_id");
      axios({
        method: "post",
        url: `${process.env.VUE_APP_API_ROOT_URL}/api/getactiveplan`,
        data: {
          userId,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
          .then((response) => {
            this.hasActivePlan = response.data.activePlan;

            console.log(this.hasActivePlan);
            if (!this.hasActivePlan) {
              window.location.href = "/my-account/manage-plan/top-up";
              return false;
            }
          })
          .catch((error) => {
            if (!this.hasActivePlan) {
              window.location.href = "/my-account/manage-plan/top-up";
              return false;
            }
            console.error(error);
          });
    },
    async searchClicked() {
      await this.fetchActivePlan();

      this.$emit("search-triggered");
    },
  },
};
</script>
